import { Box, Paper, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PaySlipGrid from "./PaySlipGrid";
import PaySlipWorkBasedGrid from "./PaySlipWorkBasedGrid";


const PaySlipLandingPage = () => {
    const [value, setValue] = useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    return (
        <Box >
            <Paper sx={{ borderRadius: "10px", maxHeight: "calc(100vh - 115px)",}}>
                <Box sx={{ width: '100%' }}>
                    <TabContext value={value}>
                        <Box>
                            <TabList sx={{
                                minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                                '& .MuiTabs-indicator': {
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: "center !important",
                                },
                            }} onChange={handleChange} aria-label="lab API tabs example">
                                <Tab label="Regular Employees" value="1" />
                                <Tab label="Work-Based Pay Employees" value="2" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{ padding: "0px", minHeight: "45px" }}>
                            <PaySlipGrid />
                        </TabPanel>
                        <TabPanel value="2" sx={{ padding: "0px" }}>
                            <PaySlipWorkBasedGrid />
                        </TabPanel>
                    </TabContext>
                </Box>
            </Paper>
            </Box>
           
    )
}

export default PaySlipLandingPage;